import {Component, Inject, Input, OnInit} from '@angular/core';
import {APP_CONFIG} from "../../api/config";
import {IAppConfig, IAppState} from "../../store/interfaces";
import {NgRedux} from "@angular-redux/store";
import {DateRangeCommon} from "../../common/date-range/date-range.common";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'past-date-range-selector',
  templateUrl: './past-date-range-selector.html',
  styleUrls: ['./past-date-range-selector.scss']
})
export class PastDateRangeSelector extends DateRangeCommon {

  @Input() form:FormGroup;

  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig,
              _ngRedux: NgRedux<IAppState>) {
    super(appConfig, _ngRedux);
    this.setDates();
  }

  setDates() {
    this.maxMappedDate = this.toStruct(new Date());
  };

  ngOnInit() {
    super.ngOnInit();
    this.form.addControl('checkInDate',new FormControl('', Validators.required));
    this.form.addControl('checkOutDate',new FormControl('', Validators.required));
  }

  openCalendar(e: Event, order: number) {
    if (order === this.dateActions.CheckInClick) {
      this.minMappedDate = null;
      this.maxMappedDate = this.toStruct(this.actualDate);
      this._endDateStruct = this._endDate? this.toStruct(this._endDate) : null;
      if(this._startDate) {
        this.startCalendarDate = {year: this._startDate.getUTCFullYear(), month: this._startDate.getUTCMonth()};
      }
      else {
        this.startCalendarDate = {year: this.actualDate.getUTCFullYear(), month: this.actualDate.getUTCMonth()};
      }
    } else if (order === this.dateActions.CheckOutClick) {
      this.minMappedDate = this._startDateStruct? this._startDateStruct : null;
      this.maxMappedDate = this.toStruct(this.actualDate);
      if(this._endDate) {
        this.startCalendarDate = {year: this._endDate.getUTCFullYear(), month: this._endDate.getUTCMonth()};
      }
      else {
        this.startCalendarDate = {year: this.actualDate.getUTCFullYear(), month: this.actualDate.getUTCMonth()};
      }
    }
    this.order = order;
    this.showCalendar = true;
  }

  onDateChange(date: NgbDateStruct) {
    if(this.order == this.dateActions.CheckInClick) {
      this.form.patchValue({checkInDate: this.fromStruct(date)});
    }
    else {
      this.form.patchValue({checkOutDate: this.fromStruct(date)});
    }
    super.onDateChange(date);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/past-date-range-selector/past-date-range-selector.ts